import React, { useState } from 'react'
import { useTimer } from 'react-timer-hook';
import '../styles/timer.css';
import '../styles/global.css';

function Timer({ expiryTimestamp }) {
const {
	seconds,
	minutes,
	pause,
	resume,
	restart,
} = useTimer({ expiryTimestamp, onExpire: () => {
	setIsBreak(!isBreak)
	const time = new Date();
	time.setSeconds(time.getSeconds() + 300);
	restart(time)
} });
const [isBreak, setIsBreak] = useState(false)


return (
	<div className="timerContainer">
		<div className="timerCol">
			{!isBreak && <div>
				<p className="has-text-success">It's work time!</p>
				</div>
			}
			{isBreak && <div>
				<p className="has-text-danger">It's break time!</p>
				</div>
		
			}
		</div>
		<div className="timerCol">
			<span>{minutes}</span>:<span>{seconds}</span>
		</div>
		<div className="timerCol">
			<button className="blueBtn" onClick={resume}>Resume</button>
			<button className="blueBtn" onClick={pause}>Pause</button>
			<button className="tealBtn" onClick={() => {
				const time = new Date();
				time.setSeconds(time.getSeconds() + 1500);
				restart(time)
			}}>Restart</button>
		</div>	
	</div>
);
}

export default Timer